import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core'
import { LocalizedWorkingStepLabel } from 'components/Localization/LocalizedWorkingStepLabel'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { WorkingStepIconSvg } from './WorkingStepIcon'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    workingStepWithDescription: {
      display: 'flex',
      flexDirection: 'column',
      flex: '0 0 auto',
      alignItems: 'center',
      width: theme.spacing(15),
      '& svg': {
        width: theme.spacing(4),
      },
    },
  })
)

export const WorkingStepIconWithDescription = (props: {
  workingStepType: WorkingStepType
}) => {
  const classes = useStyles()

  return (
    <div className={classes.workingStepWithDescription}>
      <WorkingStepIconSvg
        workingStepType={props.workingStepType}
        disableTitle
      />
      <Typography variant="caption">
        <LocalizedWorkingStepLabel workingStepType={props.workingStepType} />
      </Typography>
    </div>
  )
}
